import styled from "@emotion/styled";
import { Button, Card } from "antd";

export const DetailWrapper = styled.div`
  display: grid;
  gap: 16px;
  margin-top: 16px;
`;

export const DetailToolbar = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const DetailBackButton = styled(Button)`
  && {
    height: 40px;
    border-radius: 12px;
    font-weight: 600;
  }
`;

export const SectionCard = styled(Card)`
  height: 100%;
  border-radius: 16px;
  border: 1px solid #dbe4f0;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);

  .ant-card-body {
    padding: 24px;
  }
`;

export const SectionTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 20px;
  color: #0f2f66;
  font-size: 1.05rem;
  font-weight: 800;
`;

export const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px 32px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const Field = styled.div`
  display: grid;
  gap: 4px;
`;

export const FieldLabel = styled.span`
  color: #0f2f66;
  font-size: 0.8rem;
  font-weight: 700;
`;

export const FieldValue = styled.span`
  color: #334155;
  font-size: 0.92rem;
`;